module.exports = __webpack_public_path__ + "static/media/chanel.74b24f0e.jpg";